module.exports = __webpack_public_path__ + "img/artificial-intelligence-ai-icon.fd9315f5.svg";